<script>
import Divider from "@/components/atoms/divider";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import DividerHeading from "@/components/molecules/divider-heading";
import Titre from "@/components/atoms/titre";
import {
  monCompteCommanderANouveauEmits,
  monCompteCommanderANouveauProps,
  useMonCompteCommanderANouveau
} from "./mixin";

export default {
  name: "CommandeCommanderANouveau",
  components: { Divider, Icon, Button, DividerHeading, Titre },
  props: {
    ...monCompteCommanderANouveauProps()
  },
  emits: [...monCompteCommanderANouveauEmits()],
  setup(props, context) {
    const { addAllToCart } = useMonCompteCommanderANouveau(context);
    return { addAllToCart };
  }
};
</script>

<template>
  <div class="u-text-center">
    <div class="u-mb-md">
      <Titre
        tag="h1"
        variant="primary"
        size="md"
        class="u-mb-lg"
      >
        Commander à nouveau
      </Titre>
      <div class="u-inline-flex u-flex-align-center u-font-15">
        <p class="u-pl-md u-pr-md">
          {{ dateCommande(commande.attributes.date_commande) }}
        </p>
        <Divider
          vertical
          dotted
        />
        <p class="u-text-ellipsis u-pl-md u-pr-md u-text-left">
          <strong class="u-font-500">
            {{ commande.attributes.code }}
          </strong>
          <template v-if="commande.attributes.titre">
            <br>
            {{ commande.attributes.titre }}
          </template>
        </p>
        <Divider
          vertical
          dotted
        />
        <p class="u-pl-md u-pr-md u-font-500">
          <strong>{{ commande.attributes.nb_articles }} {{ pluralize(commande.attributes.nb_articles, 'produit') }}</strong>
        </p>
      </div>
    </div>

    <div class="u-ml-lg u-mr-lg u-ml-md@lg u-mr-md@lg">
      <Divider />
      <div class="u-flex u-flex-align-center u-flex-wrap@md u-mt-lg u-mb-lg">
        <Icon
          name="cart-add"
          size="xlg"
          class="u-flex-shrink-none u-flex-self-start"
        />
        <div class="u-ml-sm u-mr-md u-text-left">
          <h2 class="u-font-19 u-font-secondary u-font-700 u-mb-xs">
            Ajouter toute ma commande au panier
          </h2>
          <p>
            L'ensemble de votre commande sera ajoutée au panier.
            Sous réserve de la disponibilité de tous les produits.
          </p>
        </div>
        <Button
          variant="secondary"
          radius="full"
          size="md"
          class="u-flex-shrink-none"
          @click="addAllToCart()"
        >
          Ajouter toute ma commande
        </Button>
      </div>

      <DividerHeading dotted>
        OU
      </DividerHeading>

      <div class="u-flex u-flex-align-center u-flex-wrap@md u-mt-lg u-mb-lg">
        <Icon
          name="list-click"
          size="xlg"
          class="u-flex-shrink-none u-flex-self-start"
        />
        <div class="u-ml-sm u-mr-md u-text-left">
          <h2 class="u-font-19 u-font-secondary u-font-700 u-mb-xs">
            Sélectionnez des produits de ma commande
          </h2>
          <p>
            Visualisez les produits de votre commande et ajoutez à votre panier seulement ceux que vous souhaitez.
          </p>
        </div>
        <Button
          variant="secondary"
          radius="full"
          size="md"
          class="u-flex-item-none"
          :to="`/mon-compte/mes-commandes/${commande.id}/produits`"
        >
          Sélectionner des produits
        </Button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
